module.exports = __webpack_public_path__ + "static/media/DownArrow.da30e200.svg";